export default function LivePreviewIcon() {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.0114 1.98535H3.98907C3.45765 1.98535 2.948 2.19646 2.57223 2.57223C2.19646 2.948 1.98535 3.45765 1.98535 3.98907V12.0039C1.98535 12.5354 2.19646 13.045 2.57223 13.4208C2.948 13.7965 3.45765 14.0077 3.98907 14.0077H16.0114C16.5428 14.0077 17.0524 13.7965 17.4282 13.4208C17.804 13.045 18.0151 12.5354 18.0151 12.0039V3.98907C18.0151 3.45765 17.804 2.948 17.4282 2.57223C17.0524 2.19646 16.5428 1.98535 16.0114 1.98535ZM3.98907 12.0039V3.98907H16.0114V12.0039H3.98907Z"
				fill="#FBFBFB"
			/>
			<path
				d="M14.008 16.0107H5.99316V18.0145H14.008V16.0107Z"
				fill="#FBFBFB"
			/>
		</svg>
	);
}
